import { useState } from "react";
import SectionTitle from "../Common/SectionTitle";
import {
    RiSendPlaneLine,
    RiCheckLine,
    RiErrorWarningLine,
} from "react-icons/ri";

const AVAILABLE_FOR = [
    "Enterprise .NET Backend Systems",
    "API Architecture & Integration",
    "Performance Optimization & Refactoring",
    "Remote Contract / Long-Term Collaboration",
];

const Contact = () => {
    const [form, setForm] = useState({ name: "", email: "", message: "" });
    const [status, setStatus] = useState("idle"); // idle | sending | sent | error

    const handleChange = (e) =>
        setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus("sending");
        try {
            const res = await fetch(
                "https://formsubmit.co/ajax/geraldonatanael84@gmail.com",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                    body: JSON.stringify({
                        name: form.name,
                        email: form.email,
                        message: form.message,
                    }),
                },
            );
            const data = await res.json();
            if (data.success === "true" || data.success === true) {
                setStatus("sent");
                setForm({ name: "", email: "", message: "" });
            } else {
                setStatus("error");
            }
        } catch {
            setStatus("error");
        }
    };

    return (
        <>
            <style>{`
                .contact-input {
                    width: 100%;
                    padding: 10px 14px;
                    background: rgba(255,255,255,0.04);
                    border: 1px solid rgba(255,255,255,0.1);
                    border-radius: 8px;
                    color: #fff;
                    font-size: 13px;
                    font-family: inherit;
                    outline: none;
                    transition: border-color 0.18s ease, background 0.18s ease;
                    resize: none;
                }
                .contact-input::placeholder { color: rgba(255,255,255,0.25); }
                .contact-input:focus {
                    border-color: rgba(200,151,42,0.55);
                    background: rgba(200,151,42,0.04);
                }

                .btn-send {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    padding: 11px 24px;
                    border-radius: 8px;
                    border: 1px solid rgba(200,151,42,0.45);
                    background: rgba(200,151,42,0.12);
                    color: #C8972A;
                    font-size: 13px;
                    font-weight: 500;
                    font-family: inherit;
                    letter-spacing: 0.02em;
                    cursor: pointer;
                    transition: all 0.18s ease;
                }
                .btn-send:hover:not(:disabled) {
                    background: rgba(200,151,42,0.22);
                    border-color: rgba(200,151,42,0.8);
                    color: #F0C060;
                }
                .btn-send:disabled { opacity: 0.5; cursor: not-allowed; }
            `}</style>

            <SectionTitle SectionName="Contact" />

            {/* Positioning statement */}
            <p
                className="mt-4 text-gray-300 leading-relaxed"
                style={{ fontSize: "14px", maxWidth: "520px" }}
            >
                Looking to build a scalable system, improve performance, or
                integrate complex APIs?{" "}
                <span className="text-white font-medium">
                    Let's discuss how I can help.
                </span>
            </p>

            {/* Available For */}
            <div
                className="mt-6 mb-8 p-5 rounded-xl"
                style={{
                    background: "rgba(200,151,42,0.04)",
                    border: "1px solid rgba(200,151,42,0.15)",
                }}
            >
                <p
                    className="mb-3 text-gray-500"
                    style={{
                        fontSize: "10px",
                        letterSpacing: "0.22em",
                        textTransform: "uppercase",
                        fontWeight: 500,
                    }}
                >
                    Available For
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-2 gap-x-6">
                    {AVAILABLE_FOR.map((item) => (
                        <div key={item} className="flex items-center gap-2">
                            <span
                                style={{
                                    width: "5px",
                                    height: "5px",
                                    borderRadius: "50%",
                                    background: "#C8972A",
                                    flexShrink: 0,
                                }}
                            />
                            <span
                                className="text-gray-300"
                                style={{ fontSize: "13px" }}
                            >
                                {item}
                            </span>
                        </div>
                    ))}
                </div>
            </div>

            {/* ── Contact Form ── */}
            <div>
                <p
                    className="mb-4 text-gray-500"
                    style={{
                        fontSize: "10px",
                        letterSpacing: "0.22em",
                        textTransform: "uppercase",
                        fontWeight: 500,
                    }}
                >
                    Send a Message
                </p>

                {status === "sent" ? (
                    <div
                        className="flex items-center gap-3 p-4 rounded-xl"
                        style={{
                            background: "rgba(34,197,94,0.07)",
                            border: "1px solid rgba(34,197,94,0.2)",
                        }}
                    >
                        <RiCheckLine
                            size={18}
                            style={{ color: "#22c55e", flexShrink: 0 }}
                        />
                        <div>
                            <p
                                className="text-white font-medium"
                                style={{ fontSize: "13px" }}
                            >
                                Message sent successfully.
                            </p>
                            <p
                                className="text-gray-400"
                                style={{ fontSize: "12px" }}
                            >
                                I'll get back to you as soon as possible.
                            </p>
                        </div>
                    </div>
                ) : (
                    <form
                        onSubmit={handleSubmit}
                        className="flex flex-col gap-3"
                    >
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                            <div className="flex flex-col gap-1.5">
                                <label
                                    htmlFor="contact-name"
                                    className="text-gray-500"
                                    style={{
                                        fontSize: "10px",
                                        letterSpacing: "0.15em",
                                        textTransform: "uppercase",
                                    }}
                                >
                                    Name
                                </label>
                                <input
                                    id="contact-name"
                                    type="text"
                                    name="name"
                                    required
                                    placeholder="Your name"
                                    value={form.name}
                                    onChange={handleChange}
                                    className="contact-input"
                                />
                            </div>
                            <div className="flex flex-col gap-1.5">
                                <label
                                    htmlFor="contact-email"
                                    className="text-gray-500"
                                    style={{
                                        fontSize: "10px",
                                        letterSpacing: "0.15em",
                                        textTransform: "uppercase",
                                    }}
                                >
                                    Email
                                </label>
                                <input
                                    id="contact-email"
                                    type="email"
                                    name="email"
                                    required
                                    placeholder="your@email.com"
                                    value={form.email}
                                    onChange={handleChange}
                                    className="contact-input"
                                />
                            </div>
                        </div>

                        <div className="flex flex-col gap-1.5">
                            <label
                                htmlFor="contact-message"
                                className="text-gray-500"
                                style={{
                                    fontSize: "10px",
                                    letterSpacing: "0.15em",
                                    textTransform: "uppercase",
                                }}
                            >
                                Message
                            </label>
                            <textarea
                                id="contact-message"
                                name="message"
                                required
                                rows={4}
                                placeholder="Tell me about your project or opportunity..."
                                value={form.message}
                                onChange={handleChange}
                                className="contact-input"
                            />
                        </div>

                        {status === "error" && (
                            <div
                                className="flex items-center gap-2 px-4 py-3 rounded-lg"
                                style={{
                                    background: "rgba(239,68,68,0.07)",
                                    border: "1px solid rgba(239,68,68,0.2)",
                                }}
                            >
                                <RiErrorWarningLine
                                    size={15}
                                    style={{ color: "#ef4444" }}
                                />
                                <span
                                    className="text-red-400"
                                    style={{ fontSize: "12px" }}
                                >
                                    Something went wrong. Try emailing me
                                    directly.
                                </span>
                            </div>
                        )}

                        <div className="flex items-center justify-between flex-wrap gap-3 mt-1">
                            <button
                                type="submit"
                                disabled={status === "sending"}
                                className="btn-send"
                            >
                                {status === "sending" ? (
                                    <>Sending…</>
                                ) : (
                                    <>
                                        Send Message{" "}
                                        <RiSendPlaneLine size={14} />
                                    </>
                                )}
                            </button>
                            <span
                                className="text-gray-600"
                                style={{ fontSize: "11px" }}
                            >
                                Typically respond within 24h
                            </span>
                        </div>
                    </form>
                )}
            </div>
        </>
    );
};

export default Contact;
